module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-filled.b18b07ac.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-filled/fonts/Pe-icon-7-filled.woff?kinggk
 ** module id = 1603
 ** module chunks = 0
 **/